import {
  FEEDBACKS_GET,
  FEEDBACK_GET,
  FEEDBACK_EDIT,
  FEEDBACK_DELETE,
} from './reduxConstant';

export const feedbacksGet = (feedbacks) => {
  return {
    type: FEEDBACKS_GET,
    payload: {
      feedbacks,
    },
  };
};

export const feedbackEdit = (feedback) => {
  return {
    type: FEEDBACK_EDIT,
    payload: {
      feedback,
    },
  };
};

export const feedbackGet = (feedback) => {
  return {
    type: FEEDBACK_GET,
    payload: {
      feedback,
    },
  };
};

export const feedbackDelete = (feedback) => {
  return {
    type: FEEDBACK_DELETE,
    payload: {
      feedback,
    },
  };
};
